<template>
    <DModal
        :show="showModal"
        :title="__('contracts.modals.option_change_confirmation.title', { subject: subject })"
        is-big
        is-confirm
        @confirm="confirm"
        @update:show="$emit('update:showModal', $event)"
        @close="closeModal()"
    >
        <div style="padding: 15px">
            <DCard
                v-for="item in changedOptions"
                :key="item.option"
                class="mb-2 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm overflow-hidden"
                padding
            >
                <DCardHeader class="px-6 pt-6">
                    <div
                        class="d-flex justify-content-between"
                    >
                        <DCardTitle>
                            {{ item.option }}
                        </DCardTitle>
                    </div>
                </DCardHeader>

                <DCardBody>
                    <DCardText
                        v-for="(text, index) in item.texts"
                        :key="index"
                        class="mb-2 last:mb-0 flex items-start"
                    >
                        <span class="mr-2 text-gray-400">•</span>
                        <span class="text-gray-700 dark:text-gray-300">{{ text }}</span>
                    </DCardText>
                </DCardBody>
            </DCard>
        </div>
    </DModal>
</template>

<script setup>
import { __ } from '~@/Composables/translation'

defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    subject: {
        type: String,
        default: null
    },
    changedOptions: {
        type: Array,
        default: () => []
    }
})

const emit = defineEmits(['close-modal', 'update:showModal', 'confirm'])

const closeModal = () => {
    emit('close-modal')
    emit('update:showModal', false)
}

const confirm = () => {
    emit('confirm')
}
</script>

<style scoped>
.overflow-visible {
    overflow: visible;
}
</style>
